// src/stores/locarion.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useLocationStore = defineStore("location", {
  state: () => ({
    allCities: [],
    cityDistricts: [],
    isLoading: false,
  }),

  actions: {
    async getAllCities() {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/cities?pageSize=-1`, { method: "GET" });
        this.allCities = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async getCityDistricts(citId) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/districts?pageSize=-1&city_id=${citId}`, { method: "GET" });
        this.cityDistricts = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
});
